// extracted by mini-css-extract-plugin
export var banner = "_nt-0";
export var settingRow = "_nt-2";
export var titleIcon = "_nt-1";